import type {AssetLink} from '@hconnect/common/types'
import {AssetLinkType} from '@hconnect/common/types'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../api/mutations'
import {getSettingsQueryData, setSettingsQueryData} from '../../../common/providers/ApiInterface'
import type {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useEditSiloLink = (assetId: number) => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<
    AssetLink,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.editAssetLink>[0]
  >({
    mutationFn: mutations.editAssetLink,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: (editedLink, variables) => {
      notify('success', t('success.editSiloLink'))
      // params valid for attached silos
      const assetLinkTypes = [AssetLinkType.Asset, AssetLinkType.Silo]
      const assetLinkParams = {
        plantCode: variables.plantCode,
        assetId,
        fromTypes: assetLinkTypes,
        toTypes: assetLinkTypes
      }
      const prevAssetsLinks = getSettingsQueryData('assetsLinks', [assetLinkParams])
      if (!prevAssetsLinks) return
      setSettingsQueryData(
        'assetsLinks',
        [assetLinkParams],
        prevAssetsLinks.map((link) => (link.id === editedLink.id ? editedLink : link))
      )
    }
  })
}
